import { onUnmounted, watch } from "@vue/composition-api";
import useBreakPoints from "@/hooks/useBreakPoints";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default function useHideMainMenu() {
  const { portraitUp } = useBreakPoints();
  watch(portraitUp, v => emitter.emit(EVENTS.MAIN_MENU_HIDE, !v), { immediate: true });
  onUnmounted(() => emitter.emit(EVENTS.MAIN_MENU_HIDE, false));
}
